export default "__VITE_ASSET__b0372892__"